import { Button, fontStyles, Icon, IconButton } from '@monash/portal-react';
import c from './personalisation-banner.module.scss';
import bannerImg from './personalisation-banner-img.svg';
import {
  fsUpdateDoc,
  ImpersonationContext,
} from '@monash/portal-frontend-common';
import { useContext } from 'react';
import { DataContext } from '@/components/providers/data-provider/DataProvider';
import classNames from 'classnames';

const PersonalisationBanner = ({ shown, openPersonalisationModal }) => {
  const { currentUser } = useContext(ImpersonationContext);
  const { setPortalPreferences } = useContext(DataContext);
  const userDocPath = `users/${currentUser.uid}`;

  const handleClose = async () => {
    const update = {
      isHidden: true,
      updatedAt: Date.now(),
    };

    // Optimistically update
    setPortalPreferences((prev) => ({
      ...prev,
      linksPersonalisation: {
        ...(prev.linksPersonalisation ?? {}),
        banner: {
          ...(prev.linksPersonalisation?.banner ?? {}),
          ...update,
        },
      },
    }));

    await fsUpdateDoc(userDocPath, {
      'preferences.linksPersonalisation.banner': update,
    });
  };

  return (
    <div
      className={classNames(c.bannerContainer, { [c.shown]: shown })}
      inert={!shown}
    >
      <div className={c.content}>
        <div className={c.textSection}>
          <div className={c.textWrapper}>
            <div className={fontStyles.heading}>
              {`Too many links? Let's personalise your space`}
            </div>
            <div>
              Answer a few quick questions so we can customise your view for
              your needs.
            </div>
          </div>
          <Button
            className={c.personaliseButton}
            onClick={openPersonalisationModal}
          >
            Personalise now
          </Button>
        </div>
        <img src={bannerImg} className={c.image} />
      </div>
      <div className={c.closeButtonWrapper}>
        <IconButton
          icon={Icon.ArrowsMinimize}
          color="var(--canvas-text-color)"
          onClick={handleClose}
        />
      </div>
    </div>
  );
};

export default PersonalisationBanner;
